import { primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const skeletonWrapper = css`
  display: inline-block;
  margin: ${spacing.sm}px 0;
  min-width: 150px;
`;

export const deliveryEventWrapper = css`
  margin: ${spacing.sm}px 0;
`;

export const labelWrapper = css`
  display: inline-block;
  padding: 0 ${spacing.xs + 2}px;
  border-radius: 6px;
  background-color: var(--neutral-black-10);
`;

export const label = css`
  margin: 0;
  text-align: center;
  color: var(--functional-green-base);
  ${responsiveText.BODY.XS};
  ${primarySemiBoldFont};
`;
